(function(){
  /* ---- CONFIG ---- */
  var CFG = {
    sectionId: 'kw-cart-upsell',
    fetchLimit: 4,
    maxCards: 2,
    primaryIntent: 'complementary',
    fallbackIntent: 'related',
    drawerSelectors: ['cart-drawer','#cart-drawer','.cart-drawer','#sidebar-cart','.drawer--cart'],
    drawerScrollSelectors: ['.cart-drawer__items','.cart-drawer__line-items','.drawer__scrollable','.cart__items'],
    drawerFooterSelectors: ['.cart-drawer__footer','.drawer__footer','.cart__footer','[class*="footer"]'],
    cartPageSelectors: ['cart-items','#main-cart-items','.cart__items','.cart-items','form[action$="/cart"]']
  };

  var mounting=false, debounceTimer=null, poolCache={};

  function pick(sel,root){ root=root||document; for(var i=0;i<sel.length;i++){ var el=root.querySelector(sel[i]); if(el) return el; } return null; }
  function mounted(c){ return !!(c && c.querySelector('[data-kw-upsell]')); }
  function getCart(){ return fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}); }

  function localePrefix(){
    var seg = window.location.pathname.split('/')[1] || '';
    return /^[a-z]{2}(-[a-z]{2})?$/i.test(seg) ? '/' + seg : '';
  }

  function fetchPool(seedId, intent){
    var url='/recommendations/products?section_id='+CFG.sectionId+'&product_id='+seedId+'&limit='+CFG.fetchLimit+'&intent='+intent;
    return fetch(url,{headers:{'Accept':'text/html'}}).then(function(r){ return r.ok ? r.text() : ''; })
      .then(function(html){
        if(!html) return [];
        var d=new DOMParser().parseFromString(html,'text/html');
        return Array.prototype.slice.call(d.querySelectorAll('.kw-upsell__card'));
      }).catch(function(){ return []; });
  }

  function dedupe(primary, fallback, cartIds){
    var chosen=[], seen={};
    function take(cards){
      for(var i=0;i<cards.length && chosen.length<CFG.maxCards;i++){
        var id=cards[i].getAttribute('data-product-id');
        if(!id || seen[id] || cartIds.indexOf(parseInt(id,10))>-1) continue;
        seen[id]=1; chosen.push(cards[i].cloneNode(true));
      }
    }
    take(primary); take(fallback);
    return chosen;
  }

  function selectCards(seedId, cartIds){
    if(poolCache[seedId]){
      var c=poolCache[seedId];
      return Promise.resolve(dedupe(c.primary, c.fallback, cartIds));
    }
    return Promise.all([
      fetchPool(seedId, CFG.primaryIntent),
      fetchPool(seedId, CFG.fallbackIntent)
    ]).then(function(res){
      poolCache[seedId] = { primary:res[0], fallback:res[1] };
      return dedupe(res[0], res[1], cartIds);
    });
  }

  function buildBlock(cards){
    var prefix = localePrefix();
    var wrap=document.createElement('div'); wrap.className='kw-upsell'; wrap.setAttribute('data-kw-upsell','');
    var h=document.createElement('p'); h.className='kw-upsell__heading'; h.textContent='You may also like'; wrap.appendChild(h);
    var grid=document.createElement('div'); grid.className='kw-upsell__grid';
    cards.forEach(function(c){
      if(prefix){
        var links=c.querySelectorAll('a[href^="/"]');
        for(var i=0;i<links.length;i++){
          var href=links[i].getAttribute('href');
          if(href && href.indexOf(prefix+'/')!==0){ links[i].setAttribute('href', prefix + href); }
        }
      }
      grid.appendChild(c);
    });
    wrap.appendChild(grid); return wrap;
  }

  function buildSkeleton(){
    var wrap=document.createElement('div'); wrap.className='kw-upsell kw-upsell__skeleton'; wrap.setAttribute('data-kw-upsell','');
    var h=document.createElement('p'); h.className='kw-upsell__heading'; h.textContent='You may also like'; wrap.appendChild(h);
    var grid=document.createElement('div'); grid.className='kw-upsell__grid';
    for(var n=0;n<2;n++){
      var card=document.createElement('div'); card.className='kw-upsell__card';
      card.innerHTML='<div class="kw-upsell__sk kw-upsell__sk-img"></div>'+
        '<div class="kw-upsell__sk kw-upsell__sk-line" style="width:80%"></div>'+
        '<div class="kw-upsell__sk kw-upsell__sk-line" style="width:45%"></div>'+
        '<div class="kw-upsell__sk kw-upsell__sk-btn"></div>';
      grid.appendChild(card);
    }
    wrap.appendChild(grid); return wrap;
  }

  function mountTarget(){
    var drawer=pick(CFG.drawerSelectors), target=null, isPage=false;
    if(drawer){
      target=pick(CFG.drawerScrollSelectors, drawer) || drawer;
    } else {
      var page=pick(CFG.cartPageSelectors);
      if(page){ target=page; isPage=true; }
    }
    return {el:target, drawer:drawer, isPage:isPage};
  }

  function mount(){
    if(mounting) return; mounting=true;
    var container0 = pick(CFG.drawerSelectors) || pick(CFG.cartPageSelectors);
    if(container0 && mounted(container0)){ mounting=false; return; }

    getCart().then(function(cart){
      /* empty cart: render nothing, no skeleton */
      if(!cart || !cart.items || !cart.items.length){ mounting=false; return; }

      var t=mountTarget();
      if(!t.el){ mounting=false; return; }
      var container = t.drawer || t.el;
      if(mounted(container)){ mounting=false; return; }

      var skeleton=buildSkeleton();
      t.el.appendChild(skeleton);

      var seed=cart.items[0].product_id;
      var cartIds=cart.items.map(function(i){ return i.product_id; });
      return selectCards(seed, cartIds).then(function(cards){
        var current=mountTarget();
        if(skeleton.parentNode) skeleton.remove();
        if(!cards.length || !current.el){ mounting=false; return; }
        current.el.appendChild(buildBlock(cards));
        mounting=false;
      });
    }).catch(function(e){ mounting=false; console.warn('[kw-upsell] mount error', e); });
  }

  function refreshDrawerSection(){
    var drawer=pick(CFG.drawerSelectors);
    var wrap=drawer && drawer.closest('[id^="shopify-section-"]');
    if(!wrap) return Promise.resolve(false);
    var id=wrap.id.replace('shopify-section-','');
    return fetch('/?section_id='+id,{headers:{'Accept':'text/html'}}).then(function(r){ return r.text(); })
      .then(function(html){ if(html){ wrap.innerHTML=html; return true; } return false; }).catch(function(){ return false; });
  }

  function addToCart(variantId, btn){
    var label=btn.textContent; btn.disabled=true; btn.textContent='Adding…';
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({items:[{id:parseInt(variantId,10),quantity:1}]})})
      .then(function(r){ if(!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function(){
        ['cart:refresh','cart:change','cart:updated'].forEach(function(ev){ document.dispatchEvent(new CustomEvent(ev,{bubbles:true})); });
        var drawer=pick(CFG.drawerSelectors);
        if(drawer){ try{ if(typeof drawer.open==='function') drawer.open(); else if(typeof drawer.show==='function') drawer.show(); else drawer.setAttribute('open',''); }catch(e){} }
        return refreshDrawerSection();
      })
      .then(function(){ setTimeout(mount, 200); })
      .catch(function(e){ console.warn('[kw-upsell] add error', e); btn.textContent=label; btn.disabled=false; });
  }

  document.addEventListener('click', function(e){
    var btn=e.target.closest && e.target.closest('.kw-upsell__add');
    if(btn && btn.dataset.variantId){ e.preventDefault(); addToCart(btn.dataset.variantId, btn); }
  });

  var mo=new MutationObserver(function(){
    clearTimeout(debounceTimer);
    debounceTimer=setTimeout(function(){
      var drawer=pick(CFG.drawerSelectors), page=pick(CFG.cartPageSelectors);
      if((drawer && !mounted(drawer)) || (page && !mounted(page))) mount();
    }, 120);
  });
  if(document.body) mo.observe(document.body,{childList:true,subtree:true});

  if(document.readyState!=='loading') mount(); else document.addEventListener('DOMContentLoaded', mount);
})();